/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BerechnungsParameter } from './BerechnungsParameter';
import {
    BerechnungsParameterFromJSON,
    BerechnungsParameterFromJSONTyped,
    BerechnungsParameterToJSON,
} from './BerechnungsParameter';

/**
 * 
 * @export
 * @interface UmsatzBerechnungsParameter
 */
export interface UmsatzBerechnungsParameter {
    /**
     * 
     * @type {BerechnungsParameter}
     * @memberof UmsatzBerechnungsParameter
     */
    parameter: BerechnungsParameter;
    /**
     * 
     * @type {number}
     * @memberof UmsatzBerechnungsParameter
     */
    wert: number;
}

/**
 * Check if a given object implements the UmsatzBerechnungsParameter interface.
 */
export function instanceOfUmsatzBerechnungsParameter(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "parameter" in value;
    isInstance = isInstance && "wert" in value;

    return isInstance;
}

export function UmsatzBerechnungsParameterFromJSON(json: any): UmsatzBerechnungsParameter {
    return UmsatzBerechnungsParameterFromJSONTyped(json, false);
}

export function UmsatzBerechnungsParameterFromJSONTyped(json: any, ignoreDiscriminator: boolean): UmsatzBerechnungsParameter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'parameter': BerechnungsParameterFromJSON(json['parameter']),
        'wert': json['wert'],
    };
}

export function UmsatzBerechnungsParameterToJSON(value?: UmsatzBerechnungsParameter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'parameter': BerechnungsParameterToJSON(value.parameter),
        'wert': value.wert,
    };
}

